import "./App.css";
import { useLocation } from "react-router-dom";
import Home from "./pages/Home";
import Design from "./pages/Design";
import classnames from "classnames";
import NavBar from "./NavBar";
import Safety from "./pages/Safety";
import Mission from "./pages/Mission";
import Contact from "./pages/Contact";
import { Analytics } from "@vercel/analytics/react"

function App() {
  const location = useLocation();
  const darkNav = location.pathname.startsWith("/design");
  const textFill = darkNav ? "red" : "black";
  console.log(textFill);
  return (
    <div
      className={classnames("main", {
        dark: darkNav,
      })} >
      <NavBar />
        <Home />
        <section id="mission">
        <Mission />
        </section>
        <section id="threehalves">
        <Design />
        </section>
        <section id="safety">
        <Safety />
        </section>
        <section id="contact">
        <Contact />
        </section>
        <Analytics/>
    </div>
  );
}

export default App;
